import type { OnboardingState, SignupConfig } from '@denwen-msp/shared';
import { useApi } from '@/lib/query';

// Phase I (I-A): queries shared by the sign-up pages, the onboarding wizard and the banners.

export const useSignupConfig = () => useApi<SignupConfig>(['signup', 'config'], '/public/signup/config');

export interface OnboardingData {
  state: OnboardingState | null;
  company: { name: string; timezone: string; currency: string; address: string | null };
  branding: { accentColor: string; hasLogo: boolean };
}

export const ONBOARDING_KEY = ['onboarding'];
export const useOnboarding = (enabled = true) => useApi<OnboardingData>(ONBOARDING_KEY, '/onboarding', { enabled });
